module.exports = __webpack_public_path__ + "static/step_arrow.svg";